<template>
    <div class="main" id="main" ref="main">
        <div class="tasks">
            <subsidy-note :note="subsidyNote"/>
            <s-header title="代付服務" left-btn="清除" @onLeftBtn="showClearCart"/>
            <div class="title" :class="{'edit': editLocations}">
                路線
                <div class="subtitle" @click="editLocations = !editLocations" :class="{'edit': editLocations}" v-show="cartLocations.length">
                    {{ editLocations ? '儲存編輯' : '編輯順序' }}
                </div>
            </div>
            <task-item  v-show="!cartLocations.length" title="第 1 個地點" key="new" type="pay" :err="unsetTaskErr" :location="{city: '', district: '', road: ''}"/>
            <div class="origin" :class="{'edit': editLocations}">
                <SortableList lockAxis="y" :value="cartLocations" @input="sortCartLocations" :pressDelay="200">
                    <SortableItem v-for="(location, index) in cartLocations" :index="index" :key="index" :disabled="!editLocations">
                        <task-item :title="`第 ${index+1} 個地點`"
                                   :key="index"
                                   type="pay"
                                   @onDelete="onResize"
                                   :canDelete="editLocations"
                                   :location="location"/>
                    </SortableItem>
                </SortableList>
            </div>
            <div class="buttons">
                <span>您可以再新增</span>
                <router-link :to="{name: 'task', params: {type: 'pay'}}">
                    <div class="add-btn">
                        <div>地點</div>
                    </div>
                </router-link>
            </div>
        </div>
        <order-detail/>
        <div class="footer">
            <div class="price" :class="priceClass" ref="price">
                <div class="item" @click="showMinutesDetail">
                    <div class="question min">
                        <img src="@/assets/img/question-green.svg">
                    </div>
                    <div class="min">約</div>
                    <div class="minute">{{ cartMinutes }}</div>
                    <div class="min">分</div>
                </div>
                <div class="item" @click="showPriceDetail">
                    <div class="question min">
                        <img src="@/assets/img/question-green.svg">
                    </div>
                    <div>$ {{ cartPriceTotal }}</div>
                    <div class="up min">起</div>
                    <span v-if="subsidyPrice">尖峰加成</span>
                </div>
            </div>
            <div class="button" v-if="canOrder && isWork" @click="createOrder">
                選擇付款方式
                <loading loader="spinner"
                         :active="isLoading"
                         :width="25"
                         :height="25"
                         :is-full-page="false"/>
            </div>
            <div v-else class="button close">
                目前非營業時間，無法下單
            </div>
        </div>
        <minutes-detail ref="minutesDetail"/>
        <price-detail ref="priceDetail"/>
        <div class="shadow" v-if="editLocations"/>
        <clear-cart-modal ref="clearCartModal"/>
    </div>
</template>

<script>
    import Header from './components/Header';
    import TaskItem from './components/task/TaskItem';
    import { mapGetters, mapActions } from 'vuex';
    import SortableList from './components/sortable/SortableList';
    import SortableItem from './components/sortable/SortableItem';
    import PriceDetail from './components/order/PriceDetail';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import OrderDetail from './components/order/OrderDetail';
    import MinutesDetail from './components/order/MinutesDetail';
    import ClearCartModal from "./components/modal/ClearCartModal";
    import SubsidyNote from "./components/SubsidyNote";
    import DateTimeSelect from "./components/DateTimeSelect";

    export default {
        name: 'Pay',
        components: {
            's-header': Header,
            'task-item': TaskItem,
            'SortableList': SortableList,
            'SortableItem': SortableItem,
            'PriceDetail': PriceDetail,
            'loading': Loading,
            'order-detail': OrderDetail,
            'minutes-detail': MinutesDetail,
            'clear-cart-modal': ClearCartModal,
            'subsidy-note': SubsidyNote,
            'date-time-select': DateTimeSelect,
        },
        data() {
            return {
                showPay: false,
                editLocations: false,
                unsetTaskErr: '',
                priceBottom: 0,
                mainHeight: 0,
                priceLock: false,
                isLoading: false,
            }
        },
        computed: {
            priceClass() {
                return {
                    'bottom': this.priceLock
                }
            },
            reservedAt: {
                get() {
                    return this.cart.reserved_at;
                },
                set(dateTime) {
                    this.setCartData({
                        value: dateTime,
                        key: 'reserved_at'
                    });
                }
            },
            ...mapGetters(['cart', 'subsidyPrice', 'subsidyNote', 'cartLocations', 'cartLastLocation', 'cartPrice', 'cartMinutes', 'cartCoupon', 'user', 'cartId', 'canOrder', 'isWork', 'isLogin', 'cartPriceTotal'])
        },
        methods: {
            showClearCart() {
                this.$refs.clearCartModal.show();
            },
            createOrder() {
                if (!this.checkData()) {
                    return ;
                }

                this.$router.push({
                    name: 'checkout',
                    params: {
                        type: this.$route.name
                    }
                });
            },
            checkData() {
                this.unsetTaskErr = '';

                if ( ! this.cartLocations.length) {
                    this.unsetTaskErr = '請填寫地點';
                }

                return !this.unsetTaskErr;
            },
            onResize() {
                let mainHeight = this.$refs.main.getBoundingClientRect().height;
                if (this.priceLock) {
                    mainHeight = mainHeight - 40;
                }

                this.priceBottom =  this.priceBottom - (this.mainHeight - mainHeight);
                this.mainHeight = mainHeight;

                this.onScroll();
            },
            onScroll() {
                let windowBottom = window.scrollY + document.body.offsetHeight;

                if (document.body.offsetHeight < this.priceBottom && !this.priceLock) {
                    this.priceLock = true;
                }

                if (windowBottom >= (this.priceBottom)) {
                    this.priceLock = false;
                }
            },
            showPriceDetail() {
                this.$refs.priceDetail.show();
            },
            showMinutesDetail() {
                this.$refs.minutesDetail.show();
            },
            ...mapActions(['setCartData', 'sortCartLocations', 'initCart', 'getCoupons', 'setCartCoupon', 'getAgreements', 'clearCart', 'sendCart'])
        },
        created() {
            this.initCart(this.$route.name);
            if (this.isLogin) {
                this.getCoupons();
                this.getAgreements();
            }
        },
        mounted() {
            window.addEventListener('scroll', this.onScroll);
            this.$nextTick(() => {
                this.mainHeight = this.$refs.main.getBoundingClientRect().height;
                this.priceBottom = this.$refs.price.getBoundingClientRect().bottom;
                this.onScroll();
            });
        },
        destroyed() {
            window.removeEventListener('scroll', this.onScroll);
        },
        watch: {
            cartLocations() {
                if (this.cartLocations.length === 0) {
                    this.editLocations = false;
                }
            },
            isLogin() {
                if (this.isLogin) {
                    this.getCoupons();
                    this.getAgreements();
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    a {
        text-decoration: none !important;
    }

    .main {
        flex: 1;
        position: relative;
        padding-bottom: 100px;
        box-sizing: border-box;

        .footer {
            position: absolute;
            width: 100%;
            bottom: 0;
        }

        .detail {
            padding: 25px 25px 0 25px;

            .item {
                display: flex;
                justify-content: space-between;
                color: rgba(74,74,74,1);
                font-size: 14px;
                line-height: 20px;
                text-align: left;
                padding: 13px 0;
                border-bottom: solid 1px rgba(221,221,221,1);

                .span {
                    width: 130px;
                }

                .input {
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    width: calc(100% - 130px);
                    text-align: right;
                    font-size: 14px;
                    line-height: 20px;

                    &.placeholder{
                        color: rgba(155,155,155,1);
                    }

                    &.go {
                        color: rgba(51,153,51,1);
                        font-size: 14px;
                        font-weight: 500;
                        line-height: 20px;
                    }

                    img {
                        width: 20px;
                        height: 20px;
                    }

                    input {
                        text-align: right;
                        width: 100%;
                        border: none;
                        font-size: 14px;

                        &::placeholder {
                            color: rgba(155,155,155,1);
                        }
                    }
                }
            }
        }
    }

    .shadow {
        position: fixed;
        left: 0;
        top: 0;
        background-color: rgba(0,0,0,.40);
        width: 100%;
        height: 100%;
    }

    .tasks {
        background-color: rgba(250,250,250,1);
        padding-bottom: 5px;

        .title {
            color: rgba(0,0,0,1);
            font-size: 18px;
            font-weight: 500;
            line-height: 25px;
            text-align: left;
            margin-left: 25px;
            display: flex;
            align-items: flex-end;

            &.edit {
                position: relative;
                z-index: 10;
            }

            .subtitle {
                color: rgba(120,120,120,1);
                font-size: 14px;
                line-height: 20px;
                margin-left: 15px;

                &.edit {
                    color: rgba(51,153,51,1);
                    background-color: rgb(255,255,255);
                    border-radius: 5px;
                    padding: 0 3px;
                    margin-left: 12px;
                }
            }
        }

        .origin {
            margin-top: 15px;

            &.edit {
                position: relative;
                z-index: 10;
            }
        }

        .buttons {
            display: flex;
            margin: 15px 25px 15px 10px;
            align-items: center;

            span {
                margin-left: 10px;
                color: #339933;
                font-size: 14px;
                font-weight: 500;
                letter-spacing: 0;
                line-height: 20px;
            }

            .add-btn {
                cursor: pointer;
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: fit-content;
                border-radius: 20px;
                border: solid 1px #339933;
                padding: 3px 10px;
                color: #339933;
                font-size: 12px;
                height: 20px;
                margin-left: 10px;
                background-color: rgba(250,250,250,1);

                &.disable {
                    border: solid 1px #9b9b9b;
                    color: #9b9b9b;
                }

                img {
                    margin-left: 3px;
                    height: 22px;
                    width: auto;
                }
            }
        }
    }

    .footer {
        .price {
            height: 40px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            color: rgba(51,153,51,1);
            font-size: 18px;
            line-height: 21px;
            background-color: white;
            transition: all .5s ease;
            width: 100%;
            max-width: 500px;
            padding: 0 25px;
            box-sizing: border-box;

            .item {
                display: flex;
                align-items: center;
                position: relative;

                .minute {
                    margin: 0 5px;
                }

                .min {
                    font-size: 12px;
                    line-height: 17px;
                }

                span {
                    background-color: red;
                    font-size: 13px;
                    color: #fff;
                    padding: 2px 5px;
                    border-radius: 5px;
                    font-weight: 600;
                    position: absolute;
                    top: -25px;
                    right: 0;
                }
            }

            &.bottom {
                position: fixed;
                bottom: 0;
                width: 100%;
                box-shadow: 0 -1px 1px 0 rgba(51,153,51,0.35);
            }

            .question {
                margin-right: 10px;
                display: flex;
                align-items: center;
            }

            .up {
                font-size: 12px;
                line-height: 17px;
                margin-left: 5px;
            }
        }

        .button {
            border-radius: 35px;
            background-color: rgba(51,153,51,1);
            color: rgba(255,255,255,1);
            font-size: 14px;
            line-height: 20px;
            text-align: center;
            padding: 13px;
            margin: 0 15px 10px 15px;
            position: relative;
        }
    }
</style>
